import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5588377b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container pt-4"
}
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { class: "dropdown-menu" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "dropdown-item",
    href: "#",
    "data-bs-toggle": "modal",
    "data-bs-target": "#pdfModal"
  }, "Export PDF ")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "dropdown-item text-danger",
    "data-bs-toggle": "modal",
    "data-bs-target": "#deleteModal"
  }, " Delete ")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-secondary me-2",
  type: "button",
  "data-bs-toggle": "modal",
  "data-bs-target": "#exerciseFiltersModal"
}, " Filters ", -1))
const _hoisted_8 = {
  class: "btn-group",
  role: "group",
  "aria-label": "List selectors"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "btn btn-outline-primary",
  for: "indexall"
}, "All", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "btn btn-outline-primary",
  for: "myindex"
}, " My Exercises ", -1))
const _hoisted_11 = ["id", "value"]
const _hoisted_12 = ["for"]
const _hoisted_13 = { class: "list-group pt-4 pb-4" }
const _hoisted_14 = { class: "dflex" }
const _hoisted_15 = {
  class: "btn-group pb-2",
  role: "group"
}
const _hoisted_16 = {
  type: "button",
  class: "btn btn-secondary"
}
const _hoisted_17 = { class: "container ps-0 pe-0" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-1" }
const _hoisted_20 = ["value"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = {
  key: 0,
  class: "badge bg-secondary"
}
const _hoisted_25 = {
  key: 1,
  class: "badge bg-success"
}
const _hoisted_26 = {
  class: "modal fade",
  id: "exerciseFiltersModal",
  tabindex: "-1",
  "aria-labelledby": "exerciseFiltersModalLabel",
  "aria-hidden": "true"
}
const _hoisted_27 = {
  class: "modal fade",
  id: "deleteModal",
  tabindex: "-1",
  "aria-labelledby": "deleteModalLabel",
  "aria-hidden": "true"
}
const _hoisted_28 = {
  class: "modal fade",
  id: "pdfModal",
  tabindex: "-1",
  "aria-labelledby": "pdfModalLabel",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_exercise_filters_modal = _resolveComponent("exercise-filters-modal")!
  const _component_delete_exercises_modal = _resolveComponent("delete-exercises-modal")!
  const _component_export_pdf_modal = _resolveComponent("export-pdf-modal")!

  return (_ctx.authenticated)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (_ctx.adminOrEmp)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_router_link, {
                to: { name: 'new-exercise' },
                class: "btn btn-primary me-2"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" New ")
                ]),
                _: 1
              }),
              _createElementVNode("button", {
                id: "bulkActionsButton",
                class: "btn btn-secondary dropdown-toggle me-2",
                type: "button",
                "data-bs-toggle": "dropdown",
                "aria-expanded": "false",
                disabled: !_ctx.bulkOpsButtonEnabled
              }, " Bulk actions ", 8, _hoisted_2),
              _createElementVNode("ul", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    href: "#",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.duplicateExercises(_ctx.selectedExercises)))
                  }, " Duplicate ")
                ]),
                _hoisted_5,
                _hoisted_6
              ]),
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  class: "btn-check",
                  name: "indexselector",
                  id: "indexall",
                  autocomplete: "off",
                  value: "all",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.whichExercises) = $event)),
                  onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.refreshList(_ctx.whichExercises, 0, _ctx.exerciseFilters)))
                }, null, 544), [
                  [_vModelRadio, _ctx.whichExercises]
                ]),
                _hoisted_9,
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  class: "btn-check",
                  name: "indexselector",
                  id: "myindex",
                  autocomplete: "off",
                  value: "my",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.whichExercises) = $event)),
                  onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.refreshList(_ctx.whichExercises, 0, _ctx.exerciseFilters)))
                }, null, 544), [
                  [_vModelRadio, _ctx.whichExercises]
                ]),
                _hoisted_10,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otherUsers, (otherUser, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      class: "btn-check",
                      name: "indexselector",
                      id: 'otherUser' + index,
                      autocomplete: "off",
                      value: otherUser['id'],
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.whichExercises) = $event)),
                      onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.refreshList(_ctx.whichExercises, 0, _ctx.exerciseFilters)))
                    }, null, 40, _hoisted_11), [
                      [_vModelRadio, _ctx.whichExercises]
                    ]),
                    _createElementVNode("label", {
                      class: "btn btn-outline-primary",
                      for: 'otherUser' + index
                    }, _toDisplayString(otherUser["name"]), 9, _hoisted_12)
                  ], 64))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(["btn btn-secondary", _ctx.selectedPage <= 0 ? 'disabled' : '']),
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (
                  _ctx.refreshList(_ctx.whichExercises, _ctx.selectedPage - 1, _ctx.exerciseFilters)
                ))
                    }, " « ", 2),
                    _createElementVNode("button", _hoisted_16, _toDisplayString(_ctx.selectedPage + 1), 1),
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(["btn btn-secondary", _ctx.selectedPage >= _ctx.numberOfPages - 1 ? 'disabled' : '']),
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (
                  _ctx.refreshList(_ctx.whichExercises, _ctx.selectedPage + 1, _ctx.exerciseFilters)
                ))
                    }, " » ", 2)
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exercises, (exercise, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "list-group-item pt-1 ps-2 pe-0 pb-0"
                  }, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            class: "form-check-input mx-auto",
                            value: exercise,
                            onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.checkboxChanged && _ctx.checkboxChanged(...args))),
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedExercises) = $event))
                          }, null, 40, _hoisted_20), [
                            [_vModelCheckbox, _ctx.selectedExercises]
                          ]),
                          _createTextVNode(" " + _toDisplayString("#" + exercise["id"]), 1)
                        ]),
                        _createElementVNode("div", {
                          class: "col-10 ps-0",
                          role: "button",
                          onClick: ($event: any) => (_ctx.editExercise(exercise['id']))
                        }, [
                          _createElementVNode("label", {
                            class: "text-start wrap-text",
                            role: "button",
                            innerHTML: _ctx.processMath(exercise['statement'])
                          }, null, 8, _hoisted_22)
                        ], 8, _hoisted_21),
                        _createElementVNode("div", {
                          class: "col-1 ps-0",
                          role: "button",
                          onClick: ($event: any) => (_ctx.editExercise(exercise['id']))
                        }, [
                          (exercise['is_complete'] == 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_24, "In work"))
                            : (_openBlock(), _createElementBlock("span", _hoisted_25, "Complete"))
                        ], 8, _hoisted_23)
                      ])
                    ])
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createVNode(_component_exercise_filters_modal, {
                  "exercise-filters": _ctx.exerciseFilters,
                  onUpdateFilters: _ctx.updateFilters
                }, null, 8, ["exercise-filters", "onUpdateFilters"])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createVNode(_component_delete_exercises_modal, {
                  "selected-exercises": _ctx.selectedExercises,
                  onDeleteExercises: _ctx.deleteExercises
                }, null, 8, ["selected-exercises", "onDeleteExercises"])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createVNode(_component_export_pdf_modal, {
                  "selected-exercises": _ctx.selectedExercises,
                  "all-exercises": _ctx.exercises,
                  onFinishedExportPdf: _ctx.exportPdf
                }, null, 8, ["selected-exercises", "all-exercises", "onFinishedExportPdf"])
              ])
            ]))
          : _createCommentVNode("", true)
      ], 64))
    : _createCommentVNode("", true)
}